
export default {
  name: 'ProductPhysicalInfoOnCard',
  data () {
    return {
      features: [
        {
          icon: ['sx', 'green-circle', 'color-success'],
          upperText: 'Available in stock',
          lowerText: 'Fast turnaround time',
        },
        {
          icon: ['sm', 'truck', 'color-medi-2'],
          upperText: 'Secure courier delivery',
          lowerText: 'Convenience and comfort of shopping',
        },
        {
          icon: ['sx', 'clock-two', 'color-medi-2'],
          upperText: 'Fast shipping',
          lowerText: 'Directly from the manufacturer',
        },
        {
          icon: ['sx', 'wallet', 'color-medi-2'],
          upperText: 'Secure payments',
          lowerText: this.$i18n.locale === 'ro' ? 'PayU' : 'Blik, Przelewy24',
        },
      ],
    }
  },
}
